export const withComma = (n?: number) => {
  if (!n) {
    return n;
  }

  return String(n)
    .split('.')
    .map((i, idx) => (idx === 0 ? i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : i))
    .join('.');
};

export const withCommaWithUnit = (
  n?: number,
  options?: {unit?: string; placeholder?: string}
) => {
  if (!n) {
    return options?.placeholder;
  }

  return withComma(n) + (options?.unit || '');
};

export const copyText = (text: string) => {
  if (!text) {
    return false;
  }

  if (navigator.clipboard) {
    try {
      navigator.clipboard.writeText(text);

      return true;
    } catch (e) {
      return false;
    }
  }

  const textArea = document.createElement('textarea');

  textArea.value = text.trim();
  textArea.contentEditable = 'true';
  textArea.readOnly = false;
  textArea.style.whiteSpace = 'pre';
  textArea.style.position = 'absolute';
  textArea.style.left = '-1000px';
  textArea.style.top = '-1000px';

  document.body.appendChild(textArea);

  const selection = window.getSelection();

  if (selection) {
    const range = window.document.createRange();

    selection.removeAllRanges();
    range.selectNode(textArea);
    selection.addRange(range);

    const success = window.document.execCommand('copy');

    selection.removeAllRanges();
    window.document.body.removeChild(textArea);

    return success;
  }

  return false;
};

export const maskingEmailAddress = (addr: string) => {
  const [id, domain] = addr.split('@');

  const masked = id
    .split('')
    .map((digit, idx) => {
      if (idx > 0 && (idx !== id.length - 1 || id.length === 2)) {
        return '*';
      }
      return digit;
    })
    .join('');

  return `${masked}@${domain}`;
};

export const addDashPhoneNumber = (n: string) =>
  n?.length
    ? n
        .replace(/[^0-9]/g, '')
        .replace(
          /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
          '$1-$2-$3'
        )
        .replace('--', '-')
    : n;
